import React from 'react';
import {
  Box, Typography, Paper, Stack, Avatar, Divider,
} from '@mui/material';

const groupByMonth = (notifications) => {
  return notifications.reduce((acc, note) => {
    const date = new Date(note.date);
    const monthYear = date.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
    if (!acc[monthYear]) acc[monthYear] = [];
    acc[monthYear].push(note);
    return acc;
  }, {});
};

const NotificationsPanel = ({
  notifications,
  events,
  drafts,
  eventImages,
  draftImages,
  onClickEvent, // (event, userId) => void
  userId,
}) => {
  const grouped = groupByMonth(notifications);

  return (
    <Box sx={{ padding: 2, maxHeight: '80vh' }}>
      {notifications.length > 0 ? (
        Object.entries(grouped).map(([monthYear, notes], gi) => (
          <Box key={gi} mb={3}>
            <Typography variant="h6" color="primary" gutterBottom>
              {monthYear}
            </Typography>
            {notes.map((note, i) => {
              const matchedEvent = events.find(e =>
                note.message?.toLowerCase().includes(e.eventName?.toLowerCase())
              );
              const matchedDraft = drafts.find(d =>
                note.message?.toLowerCase().includes(d.eventName?.toLowerCase())
              );
              const eventImage = matchedEvent && eventImages[matchedEvent.eventId];
              const draftImage = matchedDraft && draftImages[matchedDraft._id];
              const imageUrl = draftImage || eventImage;

              return (
                <Paper
                  key={i}
                  elevation={2}
                  sx={{
                    p: 2,
                    mb: 2,
                    backgroundColor: draftImage && !eventImage ? 'rgb(213, 243, 248)' : 'white',
                    cursor: matchedEvent ? 'pointer' : 'default',
                    transition: '0.2s',
                    '&:hover': { boxShadow: 4 },
                  }}
                  onClick={() => {
                    if (matchedEvent && onClickEvent) {
                      onClickEvent(matchedEvent, userId);
                    }
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                    <Box flex={1}>
                      <Typography variant="body1" fontWeight={500}>
                        {note.message}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(note.date).toLocaleDateString(undefined, {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })}
                      </Typography>
                    </Box>
                    {imageUrl && (
                      <Avatar src={imageUrl} alt="notification" sx={{ width: 48, height: 48 }} />
                    )}
                  </Stack>
                </Paper>
              );
            })}
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary" align="center">
          No notifications available right now.
        </Typography>
      )}
      <Divider sx={{ mt: 2, mb: 1 }} />
      <Typography variant="body2" color="success.main" align="center">
        You're all caught up!!
      </Typography>
    </Box>
  );
};

export default NotificationsPanel;